

/* tslint:disable:member-ordering */
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appHighlight]',
  standalone: false
})
export class HighlightDirective {

  constructor(private el: ElementRef) { 
    //el.nativeElement.style.backgroundColor = 'yellow';
  }

  @Input() defaultColor: string = '';

  @Input('appHighlight') highlightColor: string = '';

  @HostListener('mouseenter') onMouseEnter() {
    this.highlight(this.highlightColor || this.defaultColor || 'red');
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.highlight('');
  }


  private highlight(color: string) {
    // alert('highlightColor : - ' + this.highlightColor);
    // alert('defaultColor : - ' + this.defaultColor);
    this.el.nativeElement.style.backgroundColor = color;
  }
}